export const ServerMethod = {
	REFRESH: 'refreshOrderAjax',
	SAVE: 'saveOrderAjax',
	ENTER_COUPON: 'enterCoupon',
	REMOVE_COUPON: 'removeCoupon'
}

export const Events = {
	REFRESH: "Order:request",
	BASKET_CHANGED: "Citrus.Component.Basket:update",
}

export const DEFAULT_FILE_PARAMS = {
	NAME_LENGTH_LIMIT: 17
}

export default {
	ServerMethod,
	DEFAULT_FILE_PARAMS
}
